export default __webpack_public_path__ + "static/media/Stand_Medium.498731c9.png";